var map = {
	"./01.jpg": 318,
	"./0a5d7b2f-e084-43be-bc0d-f8fc267b30c8.JPG": 319,
	"./15f594a8-becc-445f-bd90-b5f13deaff53.JPG": 320,
	"./4b5f639c6868e92635ccee306b1ecd07.JPEG": 321,
	"./6dbb9b2d-9ac4-4838-815b-e1d614adcdbc.JPG": 322,
	"./IMG_9038.JPG": 323,
	"./WhatsApp Image 2022-10-18 at 11.53.29 AM.jpeg": 324,
	"./WhatsApp Image 2022-10-18 at 12.39.28 PM (1).jpeg": 325,
	"./WhatsApp Image 2022-10-19 at 3.06.58 PM.jpeg": 326,
	"./WhatsApp Image 2023-09-14 at 18.41.49_2138c53b.jpg": 327,
	"./WhatsApp Image 2023-10-18 at 21.39.12_bbe8cd12.jpg": 328,
	"./dd974b32def51092dc7c45b87f8f192a.JPEG": 329,
	"./f67588b8490ca28797f20af94930ddda.JPEG": 330,
	"./fe253f0a-2541-43e6-b03d-8cc7d70fa576.JPG": 331,
	"./kfc-24-50.jpg": 332,
	"./kfc-24-62.jpg": 333,
	"./kfc-24-67.jpg": 334,
	"./kfc-24-81.jpg": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 317;